// EXEMPT
import type { Writable } from "ts-essentials";

import { IS_DEV, IS_NODE, IS_STAGING } from "@/__main__/constants.mjs";
import APP_URLS from "@/app/constants-app-urls.json";
import DEV_URLS from "@/app/constants-dev-urls.json";
import STG_URLS from "@/app/constants-stg-urls.json";
import globals from "@/util/global-whitelist.mjs";
import makeStrictKeysObject from "@/util/strict-keys-object.mjs";

// This is an object because we want these key values to be looked up in runtime.
// BE CAREFUL **NOT** TO MEMOIZE ANY OF THESE URLS! Always prefer key lookup.
// For example: `appURLs.CDN`, NOT `const { CDN } = appURLs;`
//
// The purpose of having these defined as a runtime lookup is so that we can
// swap these URLs from a feature flag.
export const appURLs = makeStrictKeysObject(APP_URLS);

if (IS_STAGING) {
  for (const key in STG_URLS) {
    appURLs[key] = STG_URLS[key];
  }
}

if (IS_DEV) {
  for (const key in DEV_URLS) {
    appURLs[key] = DEV_URLS[key];
  }

  if (IS_NODE)
    (appURLs as Writable<typeof appURLs>).BLITZ = "http://localhost:8080";
}

globals.__BLITZ_DEV__.appURLs = appURLs;
